module.exports = {
	"title": "CSS writing-mode property",
	"description": "Property to define whether lines of text are laid out horizontally or vertically and the direction in which blocks progress.",
	"spec": "https://drafts.csswg.org/css-writing-modes-3/#block-flow",
	"status": "cr",
	"links": [
		{
			"url": "https://developer.mozilla.org/en-US/docs/Web/CSS/writing-mode",
			"title": "MDN article"
		}
	],
	"bugs": [],
	"categories": [
		"CSS"
	],
	"stats": {
		"ie": {
			"6": "a #1",
			"7": "a #1",
			"8": "a #1",
			"9": "a #1",
			"10": "a #1",
			"11": "a #1",
			"5.5": "a #1"
		},
		"edge": {
			"12": "y",
			"13": "y",
			"14": "y"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n d #2",
			"37": "n d #2",
			"38": "n d #2",
			"39": "n d #2",
			"40": "n d #2",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "u",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"11": "y x",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y x",
			"27": "y x",
			"28": "y x",
			"29": "y x",
			"30": "y x",
			"31": "y x",
			"32": "y x",
			"33": "y x",
			"34": "y x",
			"35": "y x",
			"36": "y x",
			"37": "y x",
			"38": "y x",
			"39": "y x",
			"40": "y x",
			"41": "y x",
			"42": "y x",
			"43": "y x",
			"44": "y x",
			"45": "y x",
			"46": "y x",
			"47": "y x",
			"48": "y x",
			"49": "y x",
			"50": "y x",
			"51": "y x",
			"52": "y x",
			"53": "y x",
			"54": "y x",
			"55": "y x",
			"56": "y x",
			"57": "y x"
		},
		"safari": {
			"4": "n",
			"5": "u",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"3.1": "n",
			"3.2": "n",
			"5.1": "y x",
			"6.1": "y x",
			"7.1": "y x",
			"9.1": "y x",
			"TP": "y x"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y x",
			"27": "y x",
			"28": "y x",
			"29": "y x",
			"30": "y x",
			"31": "y x",
			"32": "y x",
			"33": "y x",
			"34": "y x",
			"35": "y x",
			"36": "y x",
			"37": "y x",
			"38": "y x",
			"39": "y x",
			"40": "y x",
			"41": "y x",
			"42": "y x",
			"43": "y x",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "y x",
			"10": "y x",
			"3.2": "u",
			"4.0-4.1": "u",
			"4.2-4.3": "u",
			"5.0-5.1": "y x",
			"6.0-6.1": "y x",
			"7.0-7.1": "y x",
			"8.1-8.4": "y x",
			"9.0-9.2": "y x",
			"9.3": "y x"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "y x",
			"4": "y x",
			"53": "y x",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "y x",
			"4.2-4.3": "y x",
			"4.4": "y x",
			"4.4.3-4.4.4": "y x"
		},
		"bb": {
			"7": "y x",
			"10": "y x"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "y x",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "y x"
		},
		"and_ff": {
			"49": "y"
		},
		"ie_mob": {
			"10": "a x",
			"11": "a x"
		},
		"and_uc": {
			"11": "y x"
		},
		"samsung": {
			"4": "y x"
		}
	},
	"notes": "",
	"notes_by_num": {
		"1": "Internet Explorer supports different values from an [earlier version of the spec](http://www.w3.org/TR/2003/CR-css3-text-20030514/#Progression), which originated from SVG.",
		"2": "Supported in Firefox under the `layout.css.vertical-text.enabled` flag"
	},
	"usage_perc_y": 87.26,
	"usage_perc_a": 5.46,
	"ucprefix": false,
	"parent": "",
	"keywords": "css,writing,direction,i18n,vertical,ltr,rtl",
	"ie_id": "",
	"chrome_id": "",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-writing-mode.json
 ** module id = 437
 ** module chunks = 0
 **/